{
  "en": {
    "join": {
      "heading": "Welcome to fobizz",
      "paragraph": "Activate access to your license group. You will receive the code from the contact person at your educational institution.",
      "button": "Activate",
      "back": "Back to homepage",
      "autoSubmitting": "Activating license …"
    }
  }
}
